module.exports = __webpack_public_path__ + "img/batches.4d57619b.svg";